module.exports = __webpack_public_path__ + "img/img1.64574781.jpeg";